import { PureComponent, ReactNode } from 'react';

import AkInlineDialog from '@atlaskit/inline-dialog';

import { translatePosition } from './utils'; // for backwards compatibility

export interface InlineDialogProps {
  provider: any;
  children: any;
  content: ReactNode;
  position?: string;
  isOpen?: boolean;
  onClose?: (args: { isOpen: boolean; event: any }) => void;
}

export interface InlineDialogState {
  isOpen: boolean;
}

// TODO: Replace usage of unsafe lifecycle methods
// eslint-disable-next-line react/no-unsafe, import/no-default-export
export default class InlineDialog extends PureComponent<
  InlineDialogProps,
  InlineDialogState
> {
  static defaultProps = {
    position: 'bottom left',
  };

  state = {
    isOpen: !!this.props.isOpen,
  };

  /* eslint react/no-unsafe: "warn" */
  UNSAFE_componentWillMount() {
    this.props.provider.register(this);
  }

  componentWillUnmount() {
    this.props.provider.unregister(this);
  }

  toggle = () => this.setState({ isOpen: !this.state.isOpen });

  open = () => this.setState({ isOpen: true });

  close = () => this.setState({ isOpen: false });

  isOpen = () => this.state.isOpen;

  render() {
    const {
      children,
      content,
      position,
      onClose = this.props.provider.close,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <AkInlineDialog
        content={content}
        placement={position ? translatePosition(position) : undefined}
        isOpen={isOpen}
        onClose={onClose}
      >
        {children}
      </AkInlineDialog>
    );
  }
}
